/* libs/shared/src/lib/ui/actionbar/actionbar.component.scss */
h4 {
  margin-bottom: 0px;
}
.subtitle-holder {
  background: #f8f9fa;
  padding: 2px 9px;
  border: 1px solid #ddd;
  border-radius: 5px;
  font-weight: bold;
  margin-top: 4px;
}
h3 {
  margin-bottom: 5px;
}
.action-navbar {
  align-items: flex-start;
  flex-direction: column;
  margin-bottom: 10px;
}
/*# sourceMappingURL=actionbar.component.css.map */
